// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__1uLId","clickedWithMouse":"MenuLabel_clickedWithMouse__1nitF","isOpen":"MenuLabel_isOpen__3C6Iz"};